// React Imports
import React, { useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports

import { IAcademyDocumentFolder } from "../../Models/IAcademyDocumentFolder";
import AcademyDocumentFolderDocuments from "./AcademyDocumentFolderDocuments";
import AcademyDocumentFolderParticipants from "./AcademyDocumentFolderParticipants";
import AcademyDocumentFolderCommandBar from "./AcademyDocumentFolderCommandbar";
import { Button, Tab, TabList, Text } from "@fluentui/react-components";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { ArrowDownloadFilled } from "@fluentui/react-icons";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { IAppUserDto } from "../../Models/IAppUserDto";

// Props
interface IAcademyDocumentFolderProps {
  allUsers: IAppUserDto[];
  academyDocumentFolder: IAcademyDocumentFolder;
  onRefreshRequested: any;
  isObserver?: boolean;
  isAdmin: boolean;
  onCopyRequested?: any;
  onUpdateRequested?: any;
}

// Function
function AcademyDocumentFolder(props: IAcademyDocumentFolderProps) {
  const [selectedTab, setSelectedTab] = useState<string>("documents");

  let title = "";

  if (
    props.academyDocumentFolder.trainingDateFrom ==
    props.academyDocumentFolder.trainingDateTo
  ) {
    title = `${props.academyDocumentFolder.title} (${new Date(
      props.academyDocumentFolder.trainingDateFrom,
    ).toLocaleDateString()})`;
  } else {
    title = `${props.academyDocumentFolder.title} (${new Date(
      props.academyDocumentFolder.trainingDateFrom,
    ).toLocaleDateString()} - ${new Date(
      props.academyDocumentFolder.trainingDateTo,
    ).toLocaleDateString()})`;
  }

  return (
    <>
      {!props.isAdmin && (
        <div className="lueb-InnerContentBlockPadding2px">
          <StackShim horizontal>
            <Button
              as="a"
              onClick={() => {
                fetchWrapper
                  .downloadFile(
                    baseUrl +
                      "/api/documents/GetDocumentFromPath?path=/DOKUMENTE/DIVERSE/" +
                      i18n.language.includes("de")
                      ? "LSMR_BROSCHUERE_DE.PDF"
                      : "LSMR_Brochure_EN.pdf",
                  )
                  .then((blob) => {
                    // Create blob link to download
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                      "download",
                      i18n.language.includes("de")
                        ? "LSMR_BROSCHUERE_DE.PDF"
                        : "LSMR_Brochure_EN.pdf",
                    );

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode?.removeChild(link);

                    return true;
                  });
              }}
              icon={<ArrowDownloadFilled />}
              appearance="subtle"
            >
              {i18n.t<string>("downloadLsmrBroschure")}
            </Button>
          </StackShim>
        </div>
      )}

      {props.isAdmin && (
        <div className="lueb-InnerContentBlockPadding2px">
          <AcademyDocumentFolderCommandBar
            allUsers={props.allUsers}
            onUpdateRequested={() => props.onUpdateRequested()}
            onCopyRequested={() => props.onCopyRequested()}
            academyFolder={props.academyDocumentFolder}
            onRefreshRequested={() => props.onRefreshRequested()}
          />{" "}
        </div>
      )}

      <div className="lueb-ContentBlock">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text style={{ fontWeight: "bold" }}>
            {i18n.t<string>("trainer")}
          </Text>

          {props.academyDocumentFolder.trainer?.map((trainer) => (
            <Text style={{ fontWeight: "normal" }}>{trainer.fullName}</Text>
          ))}

          {props.academyDocumentFolder.suggestedRefreshDate && (
            <Text style={{ fontWeight: "bold" }}>
              {i18n.t<string>("refreshDate")}
            </Text>
          )}

          {props.academyDocumentFolder.suggestedRefreshDate && (
            <Text>
              {new Date(
                props.academyDocumentFolder.suggestedRefreshDate,
              ).toLocaleDateString()}
            </Text>
          )}

          <Text style={{ fontWeight: "bold" }}>
            {i18n.t<string>("description") + ":"}
          </Text>

          <div
            dangerouslySetInnerHTML={{
              __html: props.academyDocumentFolder.description
                ? props.academyDocumentFolder.description
                : "<div></div>",
            }}
          />
        </div>
      </div>
      <TabList selectedValue={selectedTab}>
        <Tab
          onClick={() => {
            setSelectedTab("documents");
          }}
          value={"documents"}
        >
          {i18n.t<string>("documents")}
        </Tab>
        {(props.isAdmin || props.isObserver) && (
          <Tab
            onClick={() => {
              setSelectedTab("participants");
            }}
            value={"participants"}
          >
            {i18n.t<string>("participants")}
          </Tab>
        )}
      </TabList>
      <div className="lueb-ContentBlock">
        {selectedTab == "documents" && (
          <AcademyDocumentFolderDocuments
            folderGuid={props.academyDocumentFolder.guid}
            isAdmin={props.isAdmin}
            documents={
              props.academyDocumentFolder.academyDocumentFolder2UserDocuments
            }
            refreshRequested={() => props.onRefreshRequested()}
          />
        )}
        {selectedTab == "participants" && (
          <AcademyDocumentFolderParticipants
            isAdmin={props.isAdmin}
            academyFolderGuid={props.academyDocumentFolder.guid}
            participants={
              props.academyDocumentFolder.academyDocumentFolder2AppUsers
            }
            onRefreshRequested={() => props.onRefreshRequested()}
          />
        )}
      </div>
    </>
  );
}

// Export Function
export default AcademyDocumentFolder;
